export default __webpack_public_path__ + "static/media/snark-medium-roast.b47fa1dc.png";